import { render } from "./signup.vue?vue&type=template&id=dc20b53c&scoped=true"
import script from "./signup.vue?vue&type=script&lang=js"
export * from "./signup.vue?vue&type=script&lang=js"

import "./signup.vue?vue&type=style&index=0&id=dc20b53c&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-auth/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc20b53c"]])

export default __exports__